<template>
  <div id="match-group">
    <comp-header
      :pageTitle="headerPageTitle"
      :leftIcon="headerLeftIcon"
      :leftClick="headerLeftAction"
      :rightIcon="headerRightIcon"
      :rightClick="headerRightAction"
    />
    <!-- 초대할 친구 리스트 -->
    <template v-if="inviteDatas.length != 0">
      <comp-list-item
        v-for="data in inviteDatas"
        :key="data.mrid"
        :isVisibleSelector="updateSelector(data.userSeqId)"
        :selectorType="groupListMode == 'delegate' ? 'radio' : 'checkbox'"
        :userName="
          data.userseqid == userSeqId
            ? data.matchusername.split('')[0]
            : data.username.split('')[0]
        "
        :fullName="
          data.userseqid == userSeqId ? data.matchusername : data.username
        "
        :matchingRate="data.result"
        :userSeqId="
          data.userseqid == userSeqId ? data.matchuserseqid : data.userseqid
        "
        :profileImage="data.matchuserphoto"
        @itemSelected="
          value => {
            listItemSelected(value);
          }
        "
      />
    </template>
    <!-- 그룹 멤버 리스트 -->
    <template v-else>
      <comp-list-item
        v-for="data in groupDetailData.users"
        :key="data.userSeqId"
        :isVisibleSelector="updateSelector(data.userSeqId)"
        :selectorType="groupListMode == 'delegate' ? 'radio' : 'checkbox'"
        :leaderFlag="groupDetailData.masterSeqId == data.userSeqId ? 'on' : ''"
        :userName="data.nickname.split('')[0]"
        :fullName="data.name"
        :matchingRate="data.matchPersent"
        :userSeqId="data.userSeqId"
        :profileImage="data.matchUserPhoto"
        @getMatchResult="
          getMatchResult(data.userSeqId, data.name, data.matchPersent)
        "
        @itemSelected="
          value => {
            listItemSelected(value);
          }
        "
      />
    </template>
    <comp-group-manage
      v-if="isVisibleManageModal"
      :isManager="groupDetailData.masterSeqId == userSeqId"
      @invite="updateViewInvite"
      @expel="updateViewExpelMember"
      @delegation="updateViewDelegateLeader"
      @secession="isVisibleGroupDelModal = true"
      @close="isVisibleManageModal = false"
    />
    <comp-modal
      v-if="isVisibleGroupDelModal"
      @confirm="performExitGroup()"
      @cancel="isVisibleGroupDelModal = false"
      buttonTwo
    >
      <p slot="body">{{ $t("groupManage.secessionMsg") }}</p>
    </comp-modal>
    <comp-modal
      v-if="isVisibleErrorModal"
      @confirm="isVisibleErrorModal = false"
    >
      <p slot="body">{{ errorMsg }}</p>
    </comp-modal>
    <comp-loading v-if="isLoading"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompListItem from '@/components/CompListItem';
import CompGroupManage from '@/components/CompGroupManage';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import RESPONSE from '@/constants/response';

export default {
  name: 'match-group',
  mixins: [common],
  components: {
    CompHeader,
    CompListItem,
    CompGroupManage,
    CompModal,
    CompLoading,
  },
  data() {
    return {
      headerPageTitle: '',
      headerLeftIcon: 'fa-chevron-left',
      headerRightIcon: '',

      groupId: '',
      groupListMode: '',
      groupDetailData: '',
      inviteDatas: [],
      userSeqId: this.$store.getters.getUserSeqId,
      errorMsg: '',

      isVisibleManageModal: false,
      isVisibleGroupDelModal: false,
      isVisibleErrorModal: false,
      isLoading: false,

      selectedItem: '',
      selectedItems: [],
    };
  },
  methods: {
    headerLeftAction() {
      if (this.groupListMode === 'expel' || this.groupListMode === 'delegate') {
        this.groupListMode = '';
        this.updateViews();
      } else {
        this.goPrevious();
      }
    },
    headerRightAction() {
      if (this.groupListMode === 'invite') {
        this.isLoading = true;

        const data = {
          groupId: this.groupId,
          members: this.selectedItems,
        };
        // eslint-disable-next-line no-unused-vars
        this.$store.dispatch('inviteMember', data).then(({ status, inviteData }) => {
          if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.headerRightAction();
              } else {
                this.invalidateLogin();
              }
            });
          } else {
            this.goPrevious();
          }
        });
      } else if (this.groupListMode === 'expel') {
        this.isLoading = true;

        const data = {
          groupId: this.groupId,
          members: this.selectedItems,
        };
        // eslint-disable-next-line no-unused-vars
        this.$store.dispatch('expelMember', data).then(({ status, expelData }) => {
          if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.headerRightAction();
              } else {
                this.invalidateLogin();
              }
            });
          } else {
            this.goPrevious();
          }
        });
      } else if (this.groupListMode === 'delegate') {
        this.isLoading = true;

        const data = {
          groupId: this.groupId,
          userId: this.selectedItem,
        };
        this.$store
          .dispatch('delegateLeader', data)
          // eslint-disable-next-line no-unused-vars
          .then(({ status, delegateData }) => {
            if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
              this.$store.dispatch('refreshToken').then((response) => {
                if (response.status === RESPONSE.SUCCESS.CODE) {
                  this.headerRightAction();
                } else {
                  this.invalidateLogin();
                }
              });
            } else {
              this.goPrevious();
            }
          });
      } else {
        this.isVisibleManageModal = true;
      }
    },
    getGroupMemberList(groupId) {
      this.isLoading = true;

      this.$store.dispatch('getGroupMemberList', { groupId }).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getGroupMemberList(groupId);
            } else {
              this.invalidateLogin();
            }
          });
        } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
          const tmpData = data.data.data;
          const tmpUserList = tmpData.users.sort((alpha, beta) => {
            if (alpha.name < beta.name) {
              return -1;
            } else if (alpha.name > beta.name) {
              return 1;
            }
            return 0;
          });
          tmpUserList.unshift(
            tmpUserList.splice(
              tmpUserList.findIndex(
                element => element.userSeqId === tmpData.masterSeqId,
              ),
              1,
            )[0],
          );
          tmpData.users = tmpUserList;
          this.groupDetailData = tmpData;
        }
        this.isLoading = false;
      });
    },
    getMatchListForInvite() {
      const groupId = this.groupId;
      this.$store
        .dispatch('getMatchListForInvite', { groupId })
        .then(({ data, status }) => {
          if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getMatchListForInvite();
              } else {
                this.invalidateLogin();
              }
            });
          } else {
            this.inviteDatas = data.data;
          }
          this.isLoading = false;
        });
    },
    getMatchResult(id, name, matchingRate) {
      if (this.userSeqId === id) {
        this.goPage('/report');
        return;
      } else if (!matchingRate || matchingRate === 0) {
        this.isLoading = true;

        const url = `/api/v2.0/${this.$store.getters.getUserSeqId}/match/${id}`;
        this.$store.dispatch('matchAdd', { url }).then(({ status, data }) => {
          if (status === 500) {
            this.showErrorDialog('한명이 문제를 다 풀지 않았습니다.');
          } else if (status === 400 && data.resultCode === -200) {
            this.showErrorDialog(data.resultMsg);
          } else if (status === 400 && data.resultCode === -300) {
            this.showErrorDialog(data.resultMsg);
            this.isVisibleErrorModal = true;
          } else {
            location.reload();
          }
        });
        return;
      }
      this.$router.push({
        path: `/match/result/${id}`,
        query: { username: name },
      });
    },
    updateSelector(userId) {
      if (this.userSeqId === userId) {
        return false;
      } else if (
        this.groupListMode === 'invite' ||
        this.groupListMode === 'expel' ||
        this.groupListMode === 'delegate'
      ) {
        return true;
      }
      return false;
    },
    performExitGroup() {
      if (this.groupDetailData.users.length === 1) {
        this.performRemoveGroup();
      } else if (this.groupDetailData.masterSeqId === this.userSeqId) {
        this.showErrorDialog('그룹장은 그룹 탈퇴가 불가합니다');
      } else {
        const data = {
          groupId: this.groupId,
          members: [`${this.userSeqId}`],
        };
        // eslint-disable-next-line no-shadow
        this.$store.dispatch('expelMember', data).then((data) => {
          if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.performExitGroup(this.groupId);
              } else {
                this.invalidateLogin();
              }
            });
          } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
            if (data.status) {
              this.goPrevious();
            }
          }
        });
      }
    },
    performRemoveGroup() {
      const groupId = this.groupId;
      this.$store.dispatch('removeGroup', { groupId }).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.performExitGroup(groupId);
            } else {
              this.invalidateLogin();
            }
          });
        } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
          if (data.status) {
            this.goPrevious();
          }
        }
      });
    },
    showErrorDialog(errorMessage) {
      this.isLoading = false;

      this.isVisibleGroupDelModal = false;
      this.isVisibleManageModal = false;

      this.errorMsg = errorMessage || 'Error!';
      this.isVisibleErrorModal = true;
    },
    updateViewInvite() {
      this.$router.push({
        path: '/match/invite',
        query: {
          groupId: this.groupId,
          groupName: this.$route.query.groupName,
          openType: 'normal',
        },
      });
    },
    updateViewExpelMember() {
      this.groupListMode = 'expel';
      this.updateViews();
    },
    updateViewDelegateLeader() {
      this.groupListMode = 'delegate';
      this.updateViews();
    },
    listItemSelected(value) {
      if (this.groupListMode === 'invite') {
        if (this.selectedItems.indexOf(value) < 0) {
          this.selectedItems.push(value);
        } else {
          this.selectedItems.pop();
        }
        this.headerRightIcon =
          this.selectedItems.length === 0 ? '' : 'fa-user-plus';
      } else if (this.groupListMode === 'expel') {
        if (this.selectedItems.indexOf(value) < 0) {
          this.selectedItems.push(value);
        } else {
          this.selectedItems.pop();
        }
        this.headerRightIcon =
          this.selectedItems.length === 0 ? '' : 'fa-user-slash';
      } else if (this.groupListMode === 'delegate') {
        this.selectedItem = value;
        this.headerRightIcon = 'fa-crown';
      }
    },
    updateViews() {
      if (this.groupListMode === 'invite') {
        this.headerPageTitle = this.$i18n.t('match.inviteMember');
        this.headerLeftIcon = 'fa-chevron-left';
        this.headerRightIcon = '';
        this.getMatchListForInvite();
      } else if (this.groupListMode === 'expel') {
        this.headerPageTitle = this.$i18n.t('match.expelMember');
        this.headerLeftIcon = 'fa-chevron-left';
        this.headerRightIcon = '';

        this.isLoading = false;
      } else if (this.groupListMode === 'delegate') {
        this.headerPageTitle = this.$i18n.t('match.delegationLeader');
        this.headerLeftIcon = 'fa-chevron-left';
        this.headerRightIcon = '';

        this.isLoading = false;
      } else {
        this.headerPageTitle = this.$route.query.groupName;
        this.headerLeftIcon = 'fa-chevron-left';
        this.headerRightIcon = 'fa-ellipsis-v';
        this.getGroupMemberList(this.groupId);
      }
    },
  },
  created() {
    this.headerPageTitle = this.$route.query.groupName;

    this.groupId = this.$route.query.groupId;
    if (this.$route.query.type) {
      this.groupListMode = this.$route.query.type;
      this.updateViews();
    } else {
      this.headerRightIcon = 'fa-ellipsis-v';
      this.getGroupMemberList(this.groupId);
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/match/match-group.vue